import AutoTitle from 'components/AutoTitle';
import React from 'react';
import styles from './Event.module.sass';

const DataSource: React.FC<{
  subtitle: string;
  dataSource?: string;
}> = ({ subtitle, dataSource }) => {
  const title = subtitle.split('@')[0]?.trim() ?? dataSource ?? '';
  return (
    <AutoTitle className={styles['data-source']} title={title}>
      {title}
    </AutoTitle>
  );
};

export default DataSource;
